<template>
    <section class="beeldweb-wrapper light purple">
        <v-circlebg></v-circlebg>
        <h1>Highlights <br/>2021</h1>

        <v-sliderpage ref="sliderPage">
            <section class="beeldweb">
                <div class="bol-wrapper" @click.self="closePopup">

                    <div v-for="(project, index) in projects"
                         :class="{ 'bol': true, 'big': project.big }"
                         :style="{ backgroundImage: 'url( /static/img/pages/beeldweb/' + project.img + '.jpg )' }"
                         @click="openPopup( index, $event )" >
                    </div>

                </div>
                <transition name="fade">
                    <div v-if="popupIsOpen" class="popup-wrapper">
                        <div class="smart-popup" ref="smartPopup">
                            <h3>{{ popupTitle }}</h3>
                            <p>{{ popupDescription }}</p>
                            <!-- <button>Bekijk dit project</button> -->
                        </div>
                    </div>
                </transition>
            </section>
        </v-sliderpage>
    </section>
</template>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
         opacity: 0;
    }
</style>

<script>
    import SliderPage from '@/app/components/SliderPage';
    import CircleBg from '@/app/components/circles';

    import Vue from 'vue';
    import { gsap } from '@/vendor';

    export default {
        name: 'HighlightBeeldweb',
        meta: {
            title: 'Duurzaam verbeteren',
            color: '#a5147e'
        },
        components: {
            'v-sliderpage': SliderPage,
            'v-circlebg': CircleBg
        },

        data()
        {
            return {
                isMounted: false,

                projects: [
                    {
                        big: false,
                        title: 'Excellentietraject',
                        description: 'Meehelpen aan een betere wereld combineren met je passie voor auto’s. Dat is wat tien studenten van de opleiding Autotechniek gaan doen. Zij bouwen een Land Rover Defender uit 1986 om tot een volledig elektrische auto.',
                        img: 'excellentietraject'
                    },
                    { big: true, title: 'Techathon', description: 'Bram van Ierland en Tom Leemans, twee studenten van de opleiding Middenkaderfunctionaris Bouw, wonnen met hun team Techaton 2021. De jury riep hun plan voor het herontwikkelen van een Rijksvastgoedbedrijf uit tot de beste businesscase.', img: 'techaton' },

                    { big: false, title: 'De Uitblinkers', description: 'De Uitblinkers is een bijzonder project van het Entreecollege Tilburg, Willem II Betrokken, Self doen wat werkt en R-Newt. Het doel van dit project is om jongeren die dreigen uit te vallen in het mbo weer te motiveren om toch hun diploma te halen. Het programma zit vol met sport en samenwerken in het Koning Willem II stadion in Tilburg.', img: 'uitblinkers' },

                    { title: 'Introductie', description: 'Medewerkers van Fit@school zetten aan het begin van het schooljaar een mooi introductieprogramma neer voor nieuwe studenten en hun docenten. Een dag voor sportieve activiteiten, gericht op kennismaken en samenwerken.', img: 'fit-at-school' },

                    { title: 'Minister op bezoek', description: 'Maandag 27 september was minister Van Engelshoven op bezoek bij de School voor Mechatronica, Werktuigbouwkunde en Metaaltechniek. De minister volgde een les LOB, kreeg info over het talentenpaspoort van studenten, sprak met twee praktijkbegeleiders van stagebedrijf Hoppenbrouwers en bezocht praktijklokalen. Minister Van Engelshoven was onder de indruk van alles wat ze zag en hoorde. Wat haar opviel? “Dat studenten in kleine groepen werken aan zeer geavanceerde apparatuur.” En daar zijn wij dan weer enorm trots op.', img: 'minister-op-bezoek' },

                    { title: 'Onderwijsbeurs Zuid', description: 'Met maar liefst twee prachtige stands was ROC Tilburg aanwezig op de Onderwijsbeurs Zuid. Enthousiaste medewerkers en studenten voerden in twee dagen meer dan 1400 gesprekken met toekomstige leerlingen en hun ouders', img: 'onderwijsbeurs' },

                    { title: 'Studenten draaien mee met Rode Kruis', description: 'Een waardevolle praktijkervaring voor studenten met een migratieachtergrond. In samenwerking met het Rode Kruis werkten vijftien studenten een maand lang als gastheer/-vrouw op een vaccinatielocatie in Tilburg of Breda. Zowel de studenten als het Rode Kruis zijn erg enthousiast over de samenwerking.', img: 'rode-kruis' },

                    { title: 'OGT tv-show Making Memories', description: 'Op 6 juli nam docent en presentator Joris Donders alle medewerkers mee langs de bijzondere momenten van het afgelopen schooljaar. De live tv-show werd uitgezonden vanuit de LocHal en zat vol verrassende verhalen van onze ambassadeurs en nieuwe talenten.', img: 'ogt-tv-show' },

                    { title: 'Fietslessen', description: 'Leerlingen van het Schakelcollege springen regelmatig op de fiets om sportlessen te volgen op een andere locatie. Toen bleek dat niet alle leerlingen beschikten over de juiste fiets-skills, vond het Schakelcollege het tijd om deze leerlingen te helpen. Door fietslessen zijn de leerlingen zekerder in het verkeer en kunnen ze veilig de weg op!', img: 'fietslessen' },

                    { title: 'Tijd voor Vitaliteit', description: 'We trakteren alle medewerkers van Onderwijsgroep Tilburg regelmatig op activiteiten die op een positieve manier bijdragen aan de fysieke, mentale en/of emotionele vitaliteit. Zo liepen medewerkers al 12.000 Ommetjes, was er een padel- en tennistoernooi en namen medewerkers deel aan de Warandeloop', img: 'vitaliteit' },

                    { title: 'Leerateliers', description: 'We bieden startende docenten en instructeurs bij Onderwijsgroep Tilburg een inwerkprogramma van twee jaar aan. Naast individuele coaching en intervisie bestaat dat uit tien leerateliers, waar een bepaald thema centraal staat. Bijvoorbeeld: online lesgeven, examinering, lean werken en zorg- enbegeleidingsstructuur in het vo en mbo.', img: 'leerateliers' },

                    { title: 'Helpen met vaccineren', description: 'Zo’n 80 studenten van de School voor Zorg en Welzijn droegen hun steentje bij aan het gezamelijke coronavaccinatie-initiatief van huisartsen in Oosterhout. De studenten deden zo werkervaring op in een tijd waarin het niet makkelijk is om een stageplaats te vinden.', img: 'helpen-vaccineren' },

                    { title: 'Samenwerken doorstroom', description: 'De School voor Sport en Bewegen van ROC Tilburg gaat intensief samenwerken met een aantal Tilburgse scholen voor voortgezet onderwijs. Deze intensieve samenwerking maakt de overgang voor de leerling soepeler en kansrijker.', img: 'samenwerken' },

                    { title: 'Nieuwe opleiding doktersassistent', description: 'De School voor Zorg en Welzijn van ROC Tilburg is in samenwerking met Primacura gestart met een nieuwe opleiding voor doktersassistenten. Primacura is de overkoepelende organisatie voor Midden-Brabantse huisartsen. De doktersassistenten-opleiding is een BBL-opleiding. Dit wil zeggen dat studenten één dag per week naar school gaan en daarnaast werken in een huisartsenpraktijk', img: 'doktersassistentopleiding' },

                    { big: true, title: 'Monument voor 298 Squadron', description: 'Het 298 Squadron van het Defensie Helikopter Commando, gevestigd op Gilze Rijen, bestond 75 jaar. Ze vroegen onze studenten om een monument te maken. Studenten van de School voor Luchtvaarttechniek bogen zich over het ontwerp en metaalstudenten namen de productie op zich. Het monument voor het squadron van de Chinooks pronkt nu voor het squadrongebouw op de vliegbasis.', img: 'monument' },

                    { title: 'Melvin is ‘Autotechnicus van de Toekomst’', description: 'Hip Hip Hooray! Melvin van der Vegt, BBL-student van de School voor Autotechniek, heeft de titel \'Autotechnicus van de Toekomst\' binnengesleept. Bijna 1200 studenten bedrijfs- en autotechniek waagden zich aan een ultieme kennistest voor aanstormend technisch talent. Melvin kwam als beste uit de bus. Een prestatie om trots op te zijn.', img: 'autotechnicus' }
                ],

                popupIsOpen: false,
                popupTitle: '',
                popupDescription: ''
            };
        },

        computed: {
            offset()
            {
                if( !this.isMounted )
                {
                    return;
                }

                return this.$refs.sliderPage.offset;
            }
        },

        watch: {
            offset()
            {
                this.fixPopupOffset();
            }
        },

        mounted()
        {
            this.isMounted = true;
            this.openedAtOffset = 0;
        },

        methods: {
            focus()
            {
                // console.log( 'focus' );
            },
            openPopup( pIndex, e )
            {
                // set content
                this.popupTitle = this.projects[ pIndex ].title;
                this.popupDescription = this.projects[ pIndex ].description;

                // open
                this.popupIsOpen = true;

                // set position
                Vue.nextTick( () =>
                {
                    // must be next tick, since you can't tween a null target. Popup is null because of the v-if and it gets rendered in the next update tick

                    let prev = this.$el.querySelector( '.bol.selected' );
                    if( prev )
                    {
                        prev.classList.remove( 'selected' );
                    }

                    e.target.classList.add( 'selected' );

                    let boundingRect = e.target.getBoundingClientRect();
                    let pos = {
                        x: boundingRect.left + boundingRect.width / 2,
                        y: boundingRect.top + boundingRect.height / 2
                    };

                    gsap.set( this.$refs.smartPopup, {
                        left: pos.x,
                        top: pos.y
                    });

                    // ----------------
                    // solve offset (top/bottom and left/right) and set border-radius
                    // ----------------

                    // reset border radius
                    gsap.set( this.$refs.smartPopup, {
                        'border-top-left-radius': '2rem',
                        'border-top-right-radius': '2rem',
                        'border-bottom-left-radius': '2rem',
                        'border-bottom-right-radius': '2rem'
                    });

                    // determine styleTag for border-radius
                    let styleTag = 'border-';
                    let posAdustment = { x: 0, y: 0 };

                    if( pos.y < window.innerHeight / 2 )
                    {
                        styleTag += 'top-';
                        posAdustment.y = '0%';
                    }
                    else
                    {
                        styleTag += 'bottom-';
                        posAdustment.y = '-100%';
                    }

                    if( pos.x < window.innerWidth / 2 )
                    {
                        styleTag += 'left-';
                        posAdustment.x = '0%';
                    }
                    else
                    {
                        styleTag += 'right-';
                        posAdustment.x = '-100%';
                    }

                    styleTag += 'radius';

                    // set
                    gsap.set( this.$refs.smartPopup, {
                        [styleTag]: '0px',
                        x: posAdustment.x,
                        y: posAdustment.y
                    });

                    this.openedAtOffset = this.offset;

                    this.fixPopupOffset();
                });
            },

            fixPopupOffset()
            {
                // console.log( -this.openedAtOffset, this.offset, -this.openedAtOffset - this.offset );

                // check if the offset changed so far from opening the popup that it no longer justifies having the popup open
                // desktop is set to 300px, mobile depending on width

                if( Math.abs( this.openedAtOffset - this.offset ) > Math.min( 300, window.innerWidth / 2 ) )
                {
                    if( this.popupIsOpen )
                    {
                        this.closePopup();
                    }

                    return;
                }

                // set the popup to the correct offset
                // adjust a little bit when changing offset

                if( this.popupIsOpen )
                {
                    gsap.to( '.popup-wrapper', { left: -this.offset - ( this.openedAtOffset - this.offset ) / 2, duration: 0.4 });
                }
            },

            closePopup()
            {
                this.popupIsOpen = false;
                let prev = this.$el.querySelector( '.bol.selected' );
                if( prev )
                {
                    prev.classList.remove( 'selected' );
                }
            }
        }
    };
</script>
